var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLooperBendGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 144,
    viewBox: "0 0 123 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.0526316,
    d: "M163.641 136.839C159.898 141.819 147.932 150.154 130.021 143.647C107.632 135.513 98.9726 113.952 78.9898 102.772C64.241 94.5206 24.6105 82.1347 1.82234 95.8212",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.105263,
    d: "M167.334 126.397C164.131 131.741 153.103 141.281 134.609 136.682C111.493 130.932 100.627 110.395 79.5853 101.365C64.0548 94.7006 23.3467 86.5251 2.114 102.519",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.157895,
    d: "M170.123 115.813C167.497 121.464 157.526 132.104 138.653 129.463C115.062 126.161 102.109 106.872 80.2384 100.091C64.0964 95.0866 22.7567 91.2111 3.31213 109.336",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.210526,
    d: "M172 105.186C169.979 111.079 161.175 122.703 142.129 122.05C118.322 121.233 103.424 103.403 80.9645 98.9452C64.3877 95.6553 22.8694 96.1222 5.42596 116.181",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.263158,
    d: "M172.965 94.6083C171.571 100.681 164.03 113.162 145.02 114.502C121.258 116.178 104.578 100.003 81.7758 97.9178C64.946 96.3786 23.7039 101.183 8.45269 122.955",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.315789,
    d: "M173.027 84.1758C172.276 90.3611 166.081 103.562 147.315 106.882C123.859 111.032 105.579 96.6896 82.6837 96.9991C65.7852 97.2276 25.2712 106.316 12.3793 129.563",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.368421,
    d: "M172.206 73.983C172.105 80.213 167.324 93.9887 149.009 99.2524C126.114 105.832 106.436 93.4785 83.698 96.1795C66.9159 98.1731 27.574 111.447 17.1827 135.914",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.421053,
    d: "M170.534 64.1166C171.085 70.323 167.77 84.523 150.105 91.6723C128.024 100.609 107.162 90.3802 84.831 95.4432C68.3493 99.18 30.6103 116.494 22.8334 141.913",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.473684,
    d: "M168.049 54.6693C169.245 60.7841 167.433 75.2529 150.612 84.2095C129.586 95.4053 107.769 87.4132 86.0896 94.7826C70.0887 100.222 34.3663 121.385 29.2891 147.478",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.526316,
    d: "M164.797 45.7181C166.626 51.6744 166.335 66.2533 150.543 76.9192C130.802 90.2514 108.269 84.5837 87.4793 94.1788C72.1347 101.261 38.8201 126.042 36.4981 152.523",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.578947,
    d: "M160.837 37.3463C163.278 43.0788 164.514 57.6082 149.922 69.8664C131.684 85.1891 108.682 81.9077 89.0085 93.6234C74.4882 102.271 43.9464 130.399 44.4052 156.977",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.631579,
    d: "M156.233 29.6219C159.26 35.0677 162.008 49.3884 148.778 63.1046C132.241 80.2498 109.022 79.3908 90.6808 93.0988C77.1439 103.216 49.7097 134.383 52.9442 160.768",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.684211,
    d: "M151.054 22.6111C154.634 27.7106 158.863 41.6657 147.14 56.6897C132.485 75.4696 109.304 77.0423 92.4961 92.5923C80.0909 104.069 56.0648 137.933 62.0395 163.835",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.736842,
    d: "M145.38 16.3633C149.474 21.0608 155.138 34.4974 145.049 50.6644C132.438 70.8733 109.548 74.8605 94.4581 92.0822C83.3205 104.793 62.9657 140.982 71.6152 166.118",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.789474,
    d: "M139.294 10.9347C143.856 15.1785 150.895 27.9494 142.551 45.0825C132.121 66.4988 109.773 72.8569 96.5659 91.5616C86.8181 105.367 70.3576 143.486 81.5871 167.58",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.842105,
    d: "M132.881 6.35867C137.862 10.1024 146.197 22.0676 139.689 39.979C131.556 62.3682 109.995 71.0274 98.8149 91.0102C90.5635 105.759 78.1777 145.389 91.8642 168.178",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.894737,
    d: "M126.234 2.666C131.579 5.86856 141.119 16.897 136.519 35.3905C130.77 58.5074 110.233 69.3728 101.203 90.4147C94.5385 105.945 86.363 146.653 102.357 167.886",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.947368,
    d: "M119.446 -0.122961C125.096 2.50338 135.736 12.4743 133.095 31.3472C129.794 54.9384 110.505 67.8911 103.724 89.7616C98.7194 105.904 94.8439 147.243 112.969 166.688",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.611 -2C118.505 0.0213479 130.129 8.82544 129.475 27.871C128.658 51.678 110.828 66.5761 106.371 89.0355C103.081 105.612 103.548 147.131 123.607 164.574",
    stroke: "#3C45CD",
    strokeWidth: 0.930556
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLooperBendGroup);
export default __webpack_public_path__ + "static/media/looper_bend_group.ae405e079ea5e1c98900d4fd7acd6b9f.svg";
export { ForwardRef as ReactComponent };